export function cleanTypename<T>(payloadWithTypeName: T): T {

  const cleanPayload = JSON.parse(JSON.stringify(payloadWithTypeName, (name, val) => {
    if (name === '__typename') {
      delete val[name];
    } else {
      return val;
    }
  }));

  return cleanPayload
}